import React, { Component, createRef } from 'react';
import { Col, Row, Form, Button, Spinner, Modal, Container } from 'react-bootstrap';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import CloseButton from 'react-bootstrap/CloseButton';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import * as compose from "lodash.flowright";
import * as XLSX from "xlsx";
import { uploadInBatches } from "./omrUploadQueue";
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";

// /omr-upload → "OMR_Results" (see MODULE_ROUTES in moduleAccessGuard). Uploading OMR
// sheets is a WRITE, so gate it on is_edit. module_key only — no sub-module here.
const OMR_MODULE = ["OMR_Results"];

// College backend (proxies the private OMR Cloud Run engine). Always the deployed backend —
// OMR uploads/reads need the live engine, so we don't honor a localhost dev override here.
const OMR_API_BASE =
  "https://rizee-college-backend-755214126997.us-south1.run.app";

// Parse a key .xlsx and return the slno list of GRACE (ADD) questions. The key has columns
// Slo | Qtype | Answer (JEE) or Sno | KEY (NEET); a grace question has Answer == "ADD".
const parseGraceSlnos = (file) =>
  new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onerror = reject;
    fr.onload = (ev) => {
      try {
        const wb = XLSX.read(ev.target.result, { type: "binary" });
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 });
        const slnos = [];
        for (let i = 1; i < rows.length; i++) {       // skip header row
          const r = rows[i] || [];
          const slno = parseInt(r[0]);
          // Answer is the last non-empty cell (col 2 for JEE Slo|Qtype|Answer, col 1 for NEET Sno|KEY)
          const ans = String(r[2] != null && r[2] !== "" ? r[2] : (r[1] != null ? r[1] : "")).trim().toUpperCase();
          if (slno && ans === "ADD") slnos.push(slno);
        }
        resolve(slnos);
      } catch (e) { reject(e); }
    };
    fr.readAsBinaryString(file);
  });


const FETCH_EXAMNAMES = gql`
  query ($institute_id: Int!) {
    getOfflineExams(institute_id: $institute_id) {
      id
      exam_name
    }
  }
`;
const OMR_UPLOAD = gql`
  mutation UploadFiles($files: [FileInput!]!, $exam_paper_id: ID, $institute_id: ID) {
    uploadFiles(files: $files, exam_paper_id: $exam_paper_id, institute_id: $institute_id)
  }
`;
class NewOmrUpload extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption1: null,
      examDropDown: [],
      files: [],
      loader: false,
      submitError: '',
      successMessage: '',
      showConfirmModal: false,
      processing: false,
      processMsg: '',
      keyFileName: '',
      graceMsg: '',
      // Subject-wise upload: when the sheets are single-subject (one subject per sheet), staff
      // picks the exam TYPE + SUBJECT so the reader uses the right template and the answers merge
      // into the combined paper result. Left off for normal combined sheets.
      sheetKind: 'combined',    // 'combined' | 'subject'
      examType: '',             // 'jee' | 'eapcet'
      subject: '',              // 'Physics' | 'Chemistry' | 'Maths'
      // Flipped to true by the guard when a role without is_edit tries to upload.
      accessDeniedShow: false,
    };
    this.fileInputRef = createRef();

    // Uploading is a write. The Submit button stays VISIBLE; the guard intercepts and
    // opens the Access Denied modal when the role lacks is_edit on OMR_Results.
    this.guard = attachModuleGuard(this, OMR_MODULE);
  }

  componentDidMount() {
    const { getExamNames } = this.props;

    if (getExamNames && getExamNames.getOfflineExams) {
      const data = getExamNames.getOfflineExams.map((item) => ({
        value: item.id,
        label: item.exam_name,
      }));
      this.setState({ examDropDown: data }, () => {
        console.log("Dropdown data:", this.state.examDropDown);
      });
    }
  }



  componentDidUpdate(prevProps) {
    console.log("inssssss", this.props.getExamNames?.getOfflineExams);

    if (
      this.props.getExamNames?.getOfflineExams &&
      prevProps.getExamNames?.getOfflineExams !== this.props.getExamNames?.getOfflineExams
    ) {
      const data = this.props.getExamNames.getOfflineExams.map((item) => ({
        value: item.id,
        label: item.exam_name,
      }));
      this.setState({ examDropDown: data });
    }
  }

  selecthandleInputChange = (name, value) => {
    const selected = this.state.examDropDown?.find((item) => item.value === value);
    this.setState({ selectedOption1: selected });
  };

  handleChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validImages = selectedFiles.filter((file) => file.type.startsWith('image/'));

    if (validImages.length !== selectedFiles.length) {
      this.setState({ submitError: "Only image files are allowed." });
      return;
    }

    // No count cap — uploads are sent to the server in sequential batches of 15
    // (see omrUploadQueue), so any number of sheets is supported.

    // Keep the ORIGINAL filename with each file so it can be saved against the sheet.
    const promises = validImages.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve({ file: reader.result, name: file.name || "" });
        reader.onerror = (error) => reject(error);
      });
    });

    Promise.all(promises)
      .then((newFiles) => {
        this.setState((prevState) => ({
          files: [...prevState.files, ...newFiles],
          submitError: '',
        }));
      })
      .catch((error) => {
        console.error("File reading error:", error);
        this.setState({ submitError: "Failed to read files." });
      });
  };

  removeImage = (event, indexToRemove) => {
    event.preventDefault();
    const remainingFiles = this.state.files.filter((_, index) => index !== indexToRemove);
    this.setState({ files: remainingFiles }, () => {
      if (remainingFiles.length === 0 && this.fileInputRef.current) {
        this.fileInputRef.current.value = '';
      }
    });
  };

  omrSubmit = async (e) => {
    e.preventDefault();
    // Last gate before the upload mutation — the confirm modal could already be open.
    if (!this.guard.requireEdit()) { this.setState({ showConfirmModal: false }); return; }
    if (!this.state.selectedOption1 || this.state.files.length === 0) {
      this.setState({ submitError: "Please select a test and upload at least one image." });
      return;
    }
    if (this.state.sheetKind === "subject" && (!this.state.examType || !this.state.subject)) {
      this.setState({ submitError: "For subject-wise sheets, choose the exam type and subject." });
      return;
    }

    this.setState({ loader: true, submitError: '', successMessage: '' });

    try {
      await this.fileUpload();
      this.setState({
        files: [],
        selectedOption1: null,
        successMessage: "Upload successful!",
        showConfirmModal: false,
      });
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
      setTimeout(() => this.setState({ successMessage: '' }), 3000);
    } catch (error) {
      const errMsg = error?.graphQLErrors?.map(x => x.message)?.join(", ") || "Upload failed.";
      this.setState({ submitError: errMsg });
    } finally {
      this.setState({ loader: false });
    }
  };

  // Optional key file: parse the ADD (grace) questions and store them for this paper, so the
  // submit step gives full marks on those to everyone. Only identifies grace — the engine scores.
  handleKeyFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!this.state.selectedOption1) {
      this.setState({ graceMsg: "Select the exam first, then the key." });
      e.target.value = "";
      return;
    }
    this.setState({ keyFileName: file.name, graceMsg: "Reading key…" });
    try {
      const slnos = await parseGraceSlnos(file);
      const res = await fetch(`${OMR_API_BASE}/api/v1/omr/grace`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ exam_paper_id: this.state.selectedOption1.value, slnos }),
      });
      const d = await res.json();
      if (d.status >= 400) throw new Error(d.message);
      this.setState({ graceMsg: slnos.length
        ? `${slnos.length} grace (ADD) question(s) saved: ${slnos.join(", ")}`
        : "Key read — no grace (ADD) questions in it." });
    } catch (err) {
      this.setState({ graceMsg: "Key error: " + err.message });
    }
  };

  // Engine template for a subject-wise batch, from exam type + subject.
  // JEE = 25 Q/subject (jee25). EAPCET = Maths 80 (eapcet80), Physics/Chemistry 40 (eapcet40).
  subjectTemplate = () => {
    const { sheetKind, examType, subject } = this.state;
    if (sheetKind !== "subject" || !examType || !subject) return null;
    if (examType === "jee") return "jee25";
    if (examType === "eapcet") return subject === "Maths" ? "eapcet80" : "eapcet40";
    return null;
  };

  fileUpload = async () => {
    const examPaperId = this.state.selectedOption1.value;
    const subjectMode = this.state.sheetKind === "subject";
    const template = this.subjectTemplate();
    const subject = subjectMode ? this.state.subject : "";
    // `files` are already base64 data-URL strings in this component's state; wrap them so
    // uploadInBatches (which expects File-or-string) can FileReader-or-passthrough. Here they
    // are strings, so we upload them directly in batches of 15 via the same mutation.
    const files = this.state.files;
    // OMR uploads (uploadFiles mutation) must reach the DEPLOYED backend — that's where the
    // per-sheet subject/template seed + OMR engine live. Don't use a localhost dev override.
    const apiUrl = `${OMR_API_BASE}/graphql`;
    this.setState({ processing: true, processMsg: `Uploading 0/${files.length}…` });
    try {
      // No user-facing design toggle anymore — always read combined sheets with the tick-rail
      // ("new") engine, since that's the only design these physical sheets are printed in now.
      // Subject-wise templates (jee25/eapcet80/eapcet40) have no new-design calibration, so
      // those batches stay on the old (corner-fiducial) engine automatically.
      const design = subjectMode ? "old" : "new";
      const { uploaded, failedBatches } = await uploadInBatches(files, {
        apiUrl,
        examPaperId,
        instituteId: parseInt(Cookies.get("institutionid")),
        subject,           // single-subject batch: the subject + engine template (null for normal)
        template,
        design,            // which reading engine: "old" fiducial | "new" tick-rail marked design
        onProgress: ({ done, total, batch, totalBatches, phase, attempt }) => {
          const msg = phase === "retrying"
            ? `Batch ${batch}/${totalBatches} failed — retry ${attempt}… (${done}/${total})`
            : `Uploading ${done}/${total} (batch ${batch}/${totalBatches})…`;
          this.setState({ processMsg: msg });
        },
      });
      if (failedBatches.length && uploaded === 0) {
        throw new Error(`All uploads failed: ${failedBatches[0].error}`);
      }
      // Uploaded sheets are now PENDING rows. Kick off background reading (fire-and-forget);
      // the worker reads in parallel chunks and self-re-triggers until done.
      fetch(`${OMR_API_BASE}/api/v1/omr/process-chunk`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ exam_paper_id: examPaperId, template: template || undefined,
          design: design === "new" ? "new" : undefined }),
      }).catch(() => {});
      // Go straight to the live status dashboard for this exam.
      this.props.history.push(`/offline_exams/omr/status/${examPaperId}`);
    } catch (err) {
      this.setState({ processing: false, submitError: err.message });
    }
  };

  render() {
    const { getExamNames } = this.props;
    const loading1 = getExamNames?.loading;
    const error1 = getExamNames?.error;

    if (error1) {
      alert("Server Error. " + error1.message);
      return null;
    }

    return (
      <Container fluid>

        {loading1 ? (
          <Container>
            <Row className="my-2">
              <Col>
                <div className="spinner-border text-primary text-center loading-img-center"></div>
              </Col>
            </Row>
          </Container>
        ) : (

          <>
            {/* How this works — concise flow guide */}
            <div style={{ background: "#eef2f7", border: "1px solid #d7dee8", borderRadius: 10,
              padding: "12px 16px", marginBottom: 16, display: "flex", flexWrap: "wrap",
              alignItems: "center", gap: 14, fontSize: 13, color: "#7c3aed" }}>
              <span style={{ fontWeight: 700 }}><i className="fas fa-info-circle mr-2" />How it works:</span>
              {[
                "Select the exam",
                "Upload the scanned OMR sheets",
                "Sheets are read automatically (roll matched to student)",
                "Review matched / unidentified in History",
                "Submit verified results to the exam",
              ].map((t, i) => (
                <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <span style={{ background: "#7c3aed", color: "#fff", borderRadius: "50%",
                    width: 18, height: 18, display: "inline-flex", alignItems: "center",
                    justifyContent: "center", fontSize: 11, fontWeight: 700 }}>{i + 1}</span>
                  {t}
                </span>
              ))}
              <span style={{ width: "100%", color: "#6c757d", fontSize: 12, marginTop: 2 }}>
                The exam scores automatically. Upload the key only if this paper has <b>ADD grace</b> questions (full marks for all).
              </span>
            </div>

            <Row className="align-items-stretch">
              {/* Exam picker card */}
              <Col lg={4} md={12} sm={12} className="mb-3">
                <div style={{ background: "#fff", border: "1px solid #e9ecef", borderRadius: 12,
                  padding: "16px 18px", height: "100%", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#6c757d", letterSpacing: 0.4,
                    textTransform: "uppercase", marginBottom: 8 }}>
                    <i className="fas fa-clipboard-list mr-2" style={{ color: "#7c3aed" }} />Exam Name
                  </div>
                  <SelectDropDown
                    stateData={this.state.selectedOption1}
                    handleChange={this.selecthandleInputChange}
                    name="exam_type"
                    options={this.state.examDropDown}
                    placeholderName="select exam"
                  />

                  {/* Sheet kind: normal combined sheet vs single-subject sheets */}
                  <div style={{ marginTop: 14, fontSize: 12, fontWeight: 700, color: "#6c757d",
                    letterSpacing: 0.4, textTransform: "uppercase", marginBottom: 8 }}>
                    <i className="fas fa-layer-group mr-2" style={{ color: "#7c3aed" }} />Sheet type
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    {[["combined", "Combined sheet"], ["subject", "Subject-wise sheet"]].map(([k, lbl]) => (
                      <button key={k} type="button"
                        onClick={() => this.setState({ sheetKind: k })}
                        style={{ flex: 1, padding: "7px 8px", borderRadius: 8, fontSize: 12.5, fontWeight: 700,
                          cursor: "pointer",
                          border: `1.5px solid ${this.state.sheetKind === k ? "#7c3aed" : "#ced4da"}`,
                          background: this.state.sheetKind === k ? "#f3edfd" : "#fff",
                          color: this.state.sheetKind === k ? "#7c3aed" : "#495057" }}>
                        {lbl}
                      </button>
                    ))}
                  </div>

                  {this.state.sheetKind === "subject" && (
                    <div style={{ marginTop: 12 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#6c757d", marginBottom: 6 }}>
                        Exam type
                      </div>
                      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                        {[["jee", "JEE"], ["eapcet", "EAPCET"]].map(([k, lbl]) => (
                          <button key={k} type="button"
                            onClick={() => this.setState({ examType: k, subject: "" })}
                            style={{ flex: 1, padding: "7px 8px", borderRadius: 8, fontSize: 12.5, fontWeight: 700,
                              cursor: "pointer",
                              border: `1.5px solid ${this.state.examType === k ? "#7c3aed" : "#ced4da"}`,
                              background: this.state.examType === k ? "#f3edfd" : "#fff",
                              color: this.state.examType === k ? "#7c3aed" : "#495057" }}>
                            {lbl}
                          </button>
                        ))}
                      </div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#6c757d", marginBottom: 6 }}>
                        Subject (of the sheets you're uploading now)
                      </div>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {["Physics", "Chemistry", "Maths"].map((s) => (
                          <button key={s} type="button"
                            onClick={() => this.setState({ subject: s })}
                            style={{ flex: "1 1 30%", padding: "7px 8px", borderRadius: 8, fontSize: 12.5,
                              fontWeight: 700, cursor: "pointer",
                              border: `1.5px solid ${this.state.subject === s ? "#7c3aed" : "#ced4da"}`,
                              background: this.state.subject === s ? "#f3edfd" : "#fff",
                              color: this.state.subject === s ? "#7c3aed" : "#495057" }}>
                            {s}
                          </button>
                        ))}
                      </div>
                      <div style={{ color: "#6c757d", fontSize: 11.5, marginTop: 8 }}>
                        Upload each subject's sheets in its own batch; results merge by roll into one exam.
                      </div>
                    </div>
                  )}
                </div>
              </Col>

              {/* Drop-zone file card (modern, matches the Scan OMR aesthetic) */}
              <Col lg={8} md={12} sm={12} className="mb-3">
                <label htmlFor="newomr-file" style={{ display: "block", cursor: "pointer", height: "100%", margin: 0 }}>
                  <input id="newomr-file" type="file" multiple accept="image/*"
                    onChange={this.handleChange} ref={this.fileInputRef} style={{ display: "none" }} />
                  <div style={{
                    border: `1.5px dashed ${this.state.files.length ? "#7c3aed" : "#cbd5e1"}`,
                    background: this.state.files.length ? "#f4f6f9" : "#fafbfc",
                    borderRadius: 12, padding: "22px 20px", height: "100%",
                    display: "flex", alignItems: "center", gap: 16, transition: "all .15s" }}>
                    <span style={{ width: 54, height: 54, borderRadius: 12, flexShrink: 0,
                      background: this.state.files.length ? "#e7ecf3" : "#eef1f5",
                      color: "#7c3aed", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
                      <i className={`fas ${this.state.files.length ? "fa-images" : "fa-cloud-upload-alt"}`} />
                    </span>
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: "#7c3aed" }}>
                        {this.state.files.length ? `${this.state.files.length} image${this.state.files.length === 1 ? "" : "s"} selected` : "Choose OMR scan images"}
                      </div>
                      <div style={{ fontSize: 13, color: "#6c757d", marginTop: 2 }}>
                        Click to browse · JPG / PNG · up to 10 images
                      </div>
                    </div>
                  </div>
                </label>
              </Col>
            </Row>

            {/* Optional key (only to mark ADD grace questions; the exam scores the rest) */}
            <Row>
              <Col lg={6} md={12} className="mb-3">
                <label htmlFor="newomr-key" style={{ display: "block", cursor: "pointer", margin: 0 }}>
                  <input id="newomr-key" type="file" accept=".xlsx" style={{ display: "none" }}
                    onChange={this.handleKeyFile} />
                  <div style={{ border: `1.5px dashed ${this.state.keyFileName ? "#198754" : "#cbd5e1"}`,
                    background: this.state.keyFileName ? "#f3faf5" : "#fafbfc", borderRadius: 12,
                    padding: "14px 16px", display: "flex", alignItems: "center", gap: 14 }}>
                    <span style={{ width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                      background: this.state.keyFileName ? "#e3f4e9" : "#eef1f5",
                      color: this.state.keyFileName ? "#198754" : "#6c757d",
                      display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                      <i className={`fas ${this.state.keyFileName ? "fa-check" : "fa-key"}`} />
                    </span>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: "#7c3aed" }}>
                        {this.state.keyFileName || "Answer key (optional)"}
                      </div>
                      <div style={{ fontSize: 12, color: "#6c757d", marginTop: 2 }}>
                        Only used to mark <b>ADD</b> grace questions · .xlsx
                      </div>
                    </div>
                  </div>
                </label>
                {this.state.graceMsg && (
                  <div style={{ marginTop: 6, fontSize: 13, fontWeight: 600,
                    color: this.state.graceMsg.startsWith("Key error") ? "#dc3545" : "#198754" }}>
                    {this.state.graceMsg}
                  </div>
                )}
              </Col>
            </Row>

            {this.state.submitError && (
              <div className="text-danger mt-2 mb-2">{this.state.submitError}</div>
            )}

            {this.state.processMsg && (
              <div className="mt-2 mb-2" style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                background: this.state.processing ? "#eef2f7" : "#e8f5e9",
                border: `1px solid ${this.state.processing ? "#7c3aed" : "#198754"}`,
                color: this.state.processing ? "#7c3aed" : "#198754",
                borderRadius: 6, padding: "8px 14px", fontWeight: 600, fontSize: 14,
              }}>
                {this.state.processing
                  ? <Spinner size="sm" animation="border" />
                  : <i className="fas fa-check-circle" />}
                {this.state.processMsg}
              </div>
            )}
            {this.state.successMessage && (
              <div className="text-success mt-2 mb-2">{this.state.successMessage}</div>
            )}

            <Row className="mt-4">
              {this.state.files.map((item, index) => {
                const src = item && typeof item === "object" ? item.file : item;
                const name = item && typeof item === "object" ? item.name : "";
                return (
                <Col sm={3} key={index} className="mb-3 position-relative">
                  <div style={{ position: 'absolute', top: 2, right: 18, zIndex: 1,
                    background: "#fff", borderRadius: "50%", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }}>
                    <CloseButton onClick={(e) => this.removeImage(e, index)} />
                  </div>
                  <img
                    src={src}
                    alt={`preview-${index}`}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover',
                      border: '1px solid #e9ecef',
                      borderRadius: '10px',
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  />
                  {name ? (
                    <div style={{ fontSize: 11, color: "#64748b", marginTop: 4, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={name}>
                      {name}
                    </div>
                  ) : null}
                </Col>
                );
              })}
            </Row>

            {this.state.files.length > 0 && this.state.selectedOption1 != null && (
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="secondary"
                  style={{
                    background: "#7c3aed",
                    border: 'none',
                  }}
                  onClick={() => { if (this.guard.requireEdit()) this.setState({ showConfirmModal: true }); }}
                  disabled={this.state.loader}
                >
                  Submit
                </Button>
              </div>
            )}

            <Modal
              show={this.state.showConfirmModal}
              onHide={() => this.setState({ showConfirmModal: false })}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Upload</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are you sure you want to upload the files?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showConfirmModal: false })}
                >
                  No
                </Button>
                <Button
                  variant="secondary"
                  style={{
                    background: "#7c3aed",
                    border: "none",
                  }}
                  onClick={this.omrSubmit}
                  disabled={this.state.loader}
                >
                  {this.state.loader ? (
                    <>
                      <Spinner animation="border" size="sm" role="status" className="me-2" />
                      Uploading...
                    </>
                  ) : (
                    "Yes, Upload"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}

        {/* Shown when a role without is_edit clicks Submit / Yes, Upload. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </Container>
    );
  }
}

export default withRouter(
  compose(
    graphql(FETCH_EXAMNAMES, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getExamNames",
    }),
    graphql(OMR_UPLOAD, { name: "omrupload" })
  )(NewOmrUpload)
);
